import * as React from "react"
import { SVGProps } from "react"

interface SVGRProps {
  title?: string;
  titleId?: string;
}

const IconMail = ({
  title,
  titleId="tm-icon-mail",
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    {...props}
    width="1em"
    height="1em"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden={!title}
    aria-labelledby={titleId}
    role={title ? "image" : ""}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g clipPath="url(#a)" fill="#53565F">
      <path d="M15.927 4.467a.12.12 0 0 0-.134 0l-6.5 6.5A1.814 1.814 0 0 1 8 11.502a1.86 1.86 0 0 1-1.3-.534L.207 4.494a.12.12 0 0 0-.134 0A.12.12 0 0 0 0 4.581v8a1.333 1.333 0 0 0 1.333 1.333h13.334A1.333 1.333 0 0 0 16 12.581v-8a.12.12 0 0 0-.073-.114Z" />
      <path d="M7.406 10.288a.847.847 0 0 0 1.18 0l6.46-6.46a.333.333 0 0 0 .08-.34c-.073-.24-.28-.24-.46-.24H1.333c-.187 0-.387 0-.46.24a.333.333 0 0 0 .08.34l6.453 6.46Z" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" transform="translate(0 .58)" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
)

export default IconMail

